// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiPatient {
    static getAttributeTypeMap() {
        return PharmacyBiPatient.attributeTypeMap;
    }
}
PharmacyBiPatient.discriminator = undefined;
PharmacyBiPatient.additionalProperties = false;
PharmacyBiPatient.attributeTypeMap = [
    {
        "name": "address",
        "baseName": "address",
        "type": "PharmacyBiAddress"
    },
    {
        "name": "birthDate",
        "baseName": "birthDate",
        "type": "Date"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiPatient.js.map